module.exports = __webpack_public_path__ + "static/media/8OLA32.d3850b97.jpg";